export type ReportVersion = 'v1' | 'v3';

export type ReportKey =
  | 'sellThrough'
  | 'empReport'
  | 'salePerProducer'
  | 'topPerformer'
  | 'productionOverview';

const REPORT_VERSION_ROUTES: Record<ReportKey, Record<ReportVersion, string>> = {
  sellThrough: { v1: 'sell-through', v3: 'v3/sell-through' },
  empReport: { v1: 'emp-report', v3: 'v3/emp-report' },
  salePerProducer: { v1: 'sale-per-producer-report', v3: 'v3/sale-per-producer-report' },
  topPerformer: { v1: 'top-performer', v3: 'v3/top-performer' },
  productionOverview: { v1: 'production-overview', v3: 'v3/production-overview' },
};

export function getReportRoute(reportKey: ReportKey, isEnrolled: boolean): string {
  const routes = REPORT_VERSION_ROUTES[reportKey];
  const segment = isEnrolled ? routes.v3 : routes.v1;
  return `/admin/home/${segment}`;
}
